import React from "react";
import { View } from "react-native";
import { Spacing, useTheme } from "../providers/ThemeProvider";

export const Spacer = (props: { size: Spacing }) => {
  const theme = useTheme();
  return (
    <View
      style={{
        height: theme.spacing[props.size],
        width: theme.spacing[props.size],
      }}
    />
  );
};
